import { h, Component } from 'preact';
import { connect } from 'unistore/preact';
import { SketchPicker } from 'react-color';
import { onChange, convertOpacityToHex } from '../../../../controller/theme_checkout';
import common from '../../../../common/common';

class ColorPicker extends Component {
  constructor(props) {
    super(props);
    this.blockClick = this.blockClick.bind(this);
    this.onPickerColorChange = this.onPickerColorChange.bind(this, props.colorInfo.NAME);
  }

  onPickerColorChange(label, colorObj) {
    const { colorInfo, onColorChange } = this.props;
    common.log('colorPickerChange', label, {
      colorCode: colorObj.hex + convertOpacityToHex(colorObj)
    });
    if (colorInfo && onColorChange) {
      onColorChange(colorInfo.KEY, colorObj);
    }
  }

  blockClick(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  render({ colorInfo }) {
    return (
      <div onClick={this.blockClick}>
        <SketchPicker color={colorInfo.CODE} onChange={e => this.onPickerColorChange(e)} />
      </div>
    );
  }
}

export default connect(
  null,
  onChange
)(ColorPicker);



// WEBPACK FOOTER //
// ./checkout/components/async/colorpicker/index.js